<template>
    <v-card flat class="glass-background">

        <div class="header">
            <v-row dense class="justify-start">
                <v-col dense cols="auto">
                    <Headers
                    :headersTitle="'Freigabe'"
                    :headersIcon="'mdi-clipboard-outline'"
                    />
                </v-col>
            </v-row>
        </div>
        
        <div class="content">
            <div class="filters">
                <v-row dense class="justify-center align-center">
                    <v-col dense cols="auto">
                        <DropDownOwnSeats
                        v-model="selectedSeat"
                        :dropDownOwnSeats="relCardSeat"
                        />
                    </v-col>
                </v-row>
            </div>
            
            <div class="releaseArea">
                <v-card v-if="selectedSeat" class="releaseCard" elevation="24">
                    <v-row class="justify-center align-center mt-2">
                        <v-col cols="auto">
                            <v-card-title>{{ selectedSeat?.description || '-'}}</v-card-title>
                        </v-col>
                    </v-row>
                    <v-row dense class="justify-center align-center mt-n6">
                        <v-col cols="auto">
                            <v-card-subtitle>{{selectedSeat?.room || '--'}} Platz {{ selectedSeat?.name || '--' }}</v-card-subtitle>
                        </v-col>
                    </v-row>
                    <v-row dense class="justify-center align-center mt-4">
                        <v-col cols="auto">
                            <v-card flat class="datePickerCard">
                                <v-date-picker
                                v-model="selectedDates"
                                color="#008a97"
                                locale="de-DE"
                                first-day-of-week="1"
                                show-adjacent-months
                                multiple
                                :allowedDates="isDateAllowed"
                                >
                                <template #title>
                                Ausgewählte Daten
                                </template>   
                                <template #header>
                                    <!-- leerer Slot = kein Header -->
                                </template>
                                </v-date-picker>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row dense class="justify-center align-center mt-5 mb-4">
                        <v-col cols="12">
                            <v-card-actions class="justify-center">
                                <v-btn @click="showDialogSeatPlan" variant="elevated" color="onBackground" prependIcon="mdi-map-outline">Sitzplan</v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card v-else class="noSeatCard" elevation="12">
                    <img
                    :src="inpLogo"
                    class="no-seat-logo"
                    />
                </v-card>
            </div>
        </div>

        <div class="footer">
            <v-row dense class="justify-center align-center">
                <v-col cols="12">
                    <v-card class="releaseButtonCard" elevation="12">
                        <v-card-actions class="justify-center">
                            <v-btn 
                                @click="saveReleaseTimes" 
                                variant="elevated" 
                                color="#008a97" 
                                prependIcon="mdi-pencil"
                                :disabled="!isReleaseChanged"
                                >Freigabe speichern
                            </v-btn>
                            <v-btn 
                                @click="deleteReleaseTimes" 
                                variant="elevated" 
                                color="red" 
                                prependIcon="mdi-cancel"
                                :disabled="!hasSelectedDates"
                                >Freigabe löschen
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </v-card>
    
  <SeatPlanDialog
  ref="seatPlanDialogRef"
  :dialogSeatPlanImagePath="relPremise ? relPremise.image : ''"
  :dialogSeatPlanSeat="selectedSeat"/>

</template>

<script>

import Headers from '../consumables/Headers.vue'
import SeatPlanDialog from './SeatPlanDialog.vue'
import DropDownOwnSeats from '../consumables/DropDownOwnSeats.vue'
import { useTheme } from 'vuetify'
import { computed } from 'vue'
import inpLogoLight from '/assets/img/INP-Logo_claim.png'
import inpLogoDark from '/assets/img/INP-Logo_claim_dark.png'

export default {

    components: {
        Headers,
        DropDownOwnSeats,
        SeatPlanDialog,
    },

    props: {
        relCardSeat: {type: Array, default: () => []},
        relCardPremises: {type: Object, default: null}
    },

    setup() {
        const theme = useTheme()

        const isDark = computed({
            get: () => theme.global.name.value === 'dark',
            set: (val) => {
            const newTheme = val ? 'dark' : 'light'
            theme.global.name.value = newTheme
            localStorage.setItem('theme', newTheme)
            }
        })

        const inpLogo = computed(() =>
            isDark.value ? inpLogoDark : inpLogoLight
        )

        return { isDark, inpLogo }
    },

    data() {
        return {
            selectedSeat: null,
            selectedDates: [],
            releaseItems: [],
            bookedDates:[],
            isSaving: false
        }
    },

    emits: ['updateReleaseTimes', 'setOccupancy'],

    watch: {
        relCardSeat: {
            handler(val) {
                if(val && val.length > 0 && !this.selectedSeat) {
                    this.selectedSeat = val[0]
                    this.initSeatData()
                }
            },
            immediate: true
        },
    },

    computed: {
        isReleaseChanged() {
            const current = this.releaseItems.map(i => i.date).sort()

            const selected = this.selectedDates
            .map(date => this.formatDateToYMD(date))
            .sort()

            return JSON.stringify(current) !== JSON.stringify(selected)
        },

        hasSelectedDates() {
            return this.selectedDates.length > 0
        },

        relPremise() {
            if (!this.relCardPremises || !this.relCardSeat[0]) return null
            console.log('Test: Premise', this.relCardPremises)
            console.log('Test Seat:', this.relCardSeat)
            return this.relCardPremises.find(p => p.shortPrem === this.relCardSeat[0].locationPath) || null
        }
    },

    methods: {
        async initSeatData() {
            await this.loadOwnSeatOccupancy()
            await this.loadReleaseTimes()
        },

        async loadOwnSeatOccupancy() {
            if(!this.selectedSeat) return
            console.log('Watcher Seat: ', this.selectedSeat)
            try {
                const {data} = await this.$axios.get(`/api/seats/${this.selectedSeat.id}/booked-dates/`)
                this.bookedDates = data
            }catch (err) {
                console.error('Fehler beim Laden der gebuchten Daten:', err)
            }
        }, 

        async loadReleaseTimes() {
            if(!this.selectedSeat) return
            try {
                const {data} = await this.$axios.get(`/api/owner-release-items/`, {
                    params: {seat: this.selectedSeat.id}
                })
                this.releaseItems = data
                this.selectedDates = data.map(item => new Date(item.date))
            }catch (err) {
                console.error('Fehler beim Laden der Freigaben:', err)
            }
        },

        async saveReleaseTimes() {
            if (!this.selectedSeat) return
                this.isSaving = true

                const currentDates = this.releaseItems.map(item => item.date)
                const chosenDates = this.selectedDates.map(date => this.formatDateToYMD(date))

                const added = chosenDates.filter(d => !currentDates.includes(d))
                const removed = currentDates.filter(d => !chosenDates.includes(d))

                try {
                    // Neue Freigaben
                    if (added.length) {
                    await this.$axios.post(`/api/owner-release-items/`, {
                        seat: this.selectedSeat.id,
                        dates: added
                    })
                    }

                    // Gelöschte Freigaben
                    if (removed.length) {
                        for (const oldDate of removed) {
                        const item = this.releaseItems.find(i => i.date === oldDate)
                        if (item) {
                            await this.$axios.delete(`/api/owner-release-items/${item.id}/`)
                            }
                        }
                    }
                    await this.loadReleaseTimes()
                    await this.loadOwnSeatOccupancy()
                    this.$emit('updateReleaseTimes')
                    this.$emit('setOccupancy', null)
                } catch (err) {
                    console.error('Fehler beim Synchronisieren der Freigaben:', err)
                } finally {
                    this.isSaving = false
                }
        },

        async deleteReleaseTimes() {
            if(!this.selectedSeat) return
            try{
                await this.$axios.delete(`/api/owner-release-items/${this.selectedSeat.id}/clear/`)
                await this.loadReleaseTimes()
                await this.loadOwnSeatOccupancy()
                this.$emit('updateReleaseTimes')
                this.$emit('setOccupancy', null)
            }catch(err){
                console.error('Fehler beim Synchronisieren der Freigaben:', err)
            }
        },

        showDialogSeatPlan() {
            this.$refs.seatPlanDialogRef.openDialogSeatPlan()
        },

        isDateAllowed(date) {
            // Datum normalisieren
            const d = new Date(date)
            const weekday = d.getDay() // 0 = Sonntag, 6 = Samstag

            //  Wochenende sperren
            if (weekday === 0 || weekday === 6) return false

            const current = typeof date === 'string' ? date : this.formatDateToYMD(date)
            const today = new Date().toISOString().split('T')[0]

            return current >= today && !this.bookedDates.includes(current)
        },

        formatDateToYMD(date) {
            if (typeof date === 'string') return date
                const newDate = new Date(date)
                const year = newDate.getFullYear()
                const month = String(newDate.getMonth() + 1).padStart(2, '0')
                const day = String(newDate.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
    }
}

</script>

<style scoped>

.glass-background{
    height: 47.75rem;
    flex-direction: column;
    background: rgba(var(--v-theme-surface),.72) !important;
    backdrop-filter: blur(8px) saturate(120%);
    border: 1px solid rgba(var(--v-theme-surface),.35);
    border-radius: 32px;
    overflow: visible;
    padding: 1rem;
    
}
.header {
    position: relative;
    margin-top: -2rem;
    margin-left: 0.5rem;     
    z-index: 10;
    flex-shrink: 0;
    
}
.content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;     
}
.filters {
    flex-shrink: 0;
    margin-top: 0.5rem;
}
.releaseArea {
    margin-top: 1rem;
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
}
.releaseCard {
    height: 100%;
    width: 100%;
    min-height: 0;
    overflow-x: hidden;
    border-radius: 16px;
}
.datePickerCard {
    box-shadow: 0px 6px 15px hsla(0, 0%, 0%, 0.5);
    width: 100%;
    height: 100%;
    min-height: 0;
    margin-top: 1rem;
}
.v-date-picker {
    max-width: fit-content;
}
.noSeatCard {
    width: 100%;
    height: 37.2rem;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 16px;
}
.no-seat-logo {
  width: 75%;           /* oder eine andere Größe */
  height: auto;
  opacity: 0.85;          /* leicht transparent, wirkt edler */
}
.footer {
  flex-shrink: 0;
  margin-top: 0.5rem;
  padding: 0 !important;
}
.releaseButtonCard {
    margin-top: 0;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    flex-direction: row;
    flex: 1 1 auto;
    max-width: 100%;
    border-radius: 16px;
}
@media (max-width: 600px) {
    .releaseCard {
        max-height: 440px !important;
    }
    .datePickerCard {
        transform: scale(0.75);
        transform-origin: top;
    }
}
</style>